<template>
  <div>
    <b-modal
      :id="id"
      ref="confirmationRef"
      :title="title"
      ok-variant="success"
      @ok="okPressed"
    >
      <slot />
    </b-modal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  components: {
    BModal,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    onSubmit: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async okPressed(e) {
      try {
        e.preventDefault()
        await this.onSubmit()
        this.$refs.confirmationRef.hide()
        this.$emit('done')
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style>

</style>
